(function () {
  function initialize(root) {
    if (root.dataset.reviewReady === 'true') return;
    root.dataset.reviewReady = 'true';
    var cards = Array.from(root.querySelectorAll('[data-review-grid] [data-bc-review-card]')).map(function (element) {
      return { element: element, source: element.dataset.source, topics: (element.dataset.topics || '').split(','), search: element.textContent.toLocaleLowerCase() };
    });
    var sourceButtons = Array.from(root.querySelectorAll('[data-review-source]'));
    var topicButtons = Array.from(root.querySelectorAll('button[data-review-topic]'));
    var search = root.querySelector('[data-review-search]');
    var count = root.querySelector('[data-review-count]');
    var note = root.querySelector('[data-review-selection-note]');
    var more = root.querySelector('[data-review-more]');
    var initial = Number(root.dataset.initialCount) || 12;
    var allowedSources = ['public', 'all', 'google', 'yelp', 'email'];
    var allowedTopics = ['all'].concat(topicButtons.map(function (button) { return button.dataset.reviewTopic; }));
    var defaultSource = root.dataset.defaultSource || 'public';
    var state = { source: defaultSource, topic: 'all', q: '', limit: initial };
    function readURL() {
      var params = new URL(window.location.href).searchParams;
      var source = params.get('source');
      var topic = params.get('topic');
      state.source = allowedSources.indexOf(source) >= 0 ? source : defaultSource;
      state.topic = allowedTopics.indexOf(topic) >= 0 ? topic : 'all';
      state.q = (params.get('q') || '').slice(0, 200);
      state.limit = Math.max(initial, Math.min(cards.length || initial, Number(params.get('show')) || initial));
      search.value = state.q;
    }
    function writeURL(mode) {
      var url = new URL(window.location.href);
      var values = { source: state.source === defaultSource ? '' : state.source, topic: state.topic === 'all' ? '' : state.topic, q: state.q, show: state.limit > initial ? String(state.limit) : '' };
      Object.keys(values).forEach(function (key) { if (values[key]) url.searchParams.set(key, values[key]); else url.searchParams.delete(key); });
      if (url.href !== window.location.href) window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', url.href);
    }
    function sourceMatches(card) { return state.source === 'all' ? true : state.source === 'public' ? card.source === 'google' || card.source === 'yelp' : card.source === state.source; }
    function render() {
      var query = state.q.trim().toLocaleLowerCase();
      var matches = cards.filter(function (card) { return sourceMatches(card) && (state.topic === 'all' || card.topics.indexOf(state.topic) >= 0) && (!query || card.search.indexOf(query) >= 0); });
      cards.forEach(function (card) { card.element.hidden = true; });
      matches.slice(0, state.limit).forEach(function (card) { card.element.hidden = false; });
      sourceButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.reviewSource === state.source)); });
      topicButtons.forEach(function (button) {
        var topic = button.dataset.reviewTopic;
        button.hidden = topic !== 'all' && !cards.some(function (card) { return card.topics.indexOf(topic) >= 0; });
        button.setAttribute('aria-pressed', String(topic === state.topic));
      });
      count.textContent = root.dataset.countTemplate.replace('[shown]', String(Math.min(state.limit, matches.length))).replace('[count]', String(matches.length));
      note.textContent = state.source === 'email' ? root.dataset.emailNote : state.source === 'all' ? root.dataset.allNote : root.dataset.publicNote;
      more.hidden = matches.length <= state.limit;
      root.querySelector('[data-review-empty]').hidden = matches.length !== 0;
      return matches;
    }
    root.querySelector('[data-bc-review-controls]').hidden = false;
    root.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-review-source')) { state.source = button.dataset.reviewSource; state.limit = initial; }
      else if (button.hasAttribute('data-review-topic')) { state.topic = button.dataset.reviewTopic; state.limit = initial; }
      else if (button.hasAttribute('data-review-reset')) { state = { source: defaultSource, topic: 'all', q: '', limit: initial }; search.value = ''; }
      else if (button.hasAttribute('data-review-more')) {
        var previousLimit = state.limit;
        state.limit += initial;
        var matches = render();
        writeURL();
        var next = matches[previousLimit];
        if (next) { next.element.setAttribute('tabindex', '-1'); next.element.focus({ preventScroll: true }); }
        return;
      } else return;
      render();
      writeURL();
    });
    var searchTimer;
    search.addEventListener('input', function () {
      state.q = search.value.slice(0, 200);
      state.limit = initial;
      render();
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () { writeURL('replace'); }, 300);
    });
    window.addEventListener('popstate', function () { window.clearTimeout(searchTimer); readURL(); render(); });
    readURL();
    render();
  }
  function mount(scope) {
    (scope || document).querySelectorAll('[data-bc-review-wall]').forEach(initialize);
  }
  window.BuonCiboReviews = { mount: mount };
  mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
})();
